import lineofbusinessServiceGen from "./generated/lineofbusinessServiceGen";

class lineofbusinessService extends lineofbusinessServiceGen {
}

export default lineofbusinessService;